import { ReactNode } from "react";

import styled from "styled-components";

const Container = styled.div`
  overflow-y: auto;
`;

type Props = {
  children: ReactNode;
};

export const PageWrapper = ({ children }: Props): JSX.Element => (
  <Container>{children}</Container>
);
